export const blockIconsHomeEvChargerNew = (
	<span className='material-symbols-outlined'>ev_charger</span>
);
